import React, { Component, Fragment } from 'react'
import Button from '../../../components/atoms/Button';
import LabelWithInput from '../../../components/molecules/LabelWithInput'
import TextBox from '../../../components/atoms/TextBox';
import ComboBox from '../../../components/atoms/ComboBox';

export class DataRekening extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data : {},
        }
    }
    updateState = ({name, value, type}) =>{
        if(type === 'number'){
            value = value.replace(/\D/g,"")
        }
        // console.log({name, value});
        let {data} = this.state
        data[name] = value
        console.log("current dara : ", {data});
        
        this.setState({ data })
    }
    componentDidMount = () => {
        const {parameters, profileState} = this.props;
        let { data } = this.state
        let bankAccountInfo = profileState.list.bankAccountInfo
        for( let key in bankAccountInfo ){
            if(bankAccountInfo[key]){
                // if(key === 'domicileInfo'){
                    // data.domicileInfo = { country : 'Indonesia' }
                    // for( let k in bankAccountInfo[key]){
                    //     if(bankAccountInfo.domicileInfo[k] && k !== 'isPrimary'){
                    //         data.domicileInfo[k] = bankAccountInfo.domicileInfo[k]
                    //     }
                    // }
                // } else if(key !== 'documents' && key !== 'cifUID' && key !== 'status'){
                    data[key] = bankAccountInfo[key]
                // }
            }
        }
        this.setState({ data })
    }
    changeBankCode = ({target, nativeEvent}) => {
        const index = nativeEvent.target.selectedIndex;
        const text = nativeEvent.target[index].text
        const {name, value} = target;
        console.log({text, value});
        this.updateState({ name : 'bankName', value : text})
        this.updateState({ name : 'bankCode', value})

    }
    render() {
        const {col, changeStep, parameters, profileState, submit} = this.props;
        const {data} = this.state
        return (
            <Fragment>
                {/* <p>{JSON.stringify(profileState.list.bankAccountInfo)}</p> */}
                {/* <p>{JSON.stringify(data)}</p> */}

                <LabelWithInput label='Nama Bank' col={col} {...this.props} note = {null}>
                    {/* <ComboBox name='bank_code' title='Bank_Code' isLoading = {false} fieldName={{value : 'bankCode', text : 'bankAliasName'}} title='Nama Bank' data={parameters || []}/> */}
                    <ComboBox name='bank_code' title='Bank_Code' isLoading = {false} fieldName={{value : 'bankCode', text : 'bankAliasName'}} value={data.bankCode} title='Nama Bank' data={parameters} onChange={e => this.changeBankCode(e)}/>

                </LabelWithInput>

                <LabelWithInput label='No. Rekening' col={col} {...this.props} note = {null}>
                    <TextBox name='no_rek' type={'number'} value={data.accountNumber || ''} onChange={(e)=> this.updateState({ name : 'accountNumber', value : e.target.value, type : 'number'})}/>
                </LabelWithInput>

                <LabelWithInput label='Nama Pemilik Rekening' col={col} {...this.props} note = {null}>
                    <TextBox name='holder_name' value={data.accountHolderName || ''} onChange={(e)=> this.updateState({ name : 'accountHolderName', value : e.target.value})}/>
                </LabelWithInput>

                <LabelWithInput label='Cabang' col={col} {...this.props} note = {null}>
                    <TextBox name='cabang' value={data.bankBranch || ''} onChange={(e)=> this.updateState({ name : 'bankBranch', value : e.target.value})}/>
                </LabelWithInput>

                <LabelWithInput label='Kota' col={col} {...this.props} note = {null}>
                    <TextBox name='kota' value={data.bankCity || ''} onChange={(e)=> this.updateState({ name : 'bankCity', value : e.target.value})}/>
                </LabelWithInput>

                <div className='bg-button add-margin'>
                    <Button onClick={() => submit(data, true)} width='big' color='outline' title='Sebelumnya' />
                    <Button onClick={() => submit(data, false)} width='big' color='blue' title='Selanjutnya' />
                </div>
            </Fragment>
        )
    }
}

export default DataRekening
